import { CatchDetailsRow } from './CatchDetailsRow';
import { getCatchDetailsTableData } from './getCatchDetailsTableData';

interface CatchDetailsTableProps {
  catchAndRelease: boolean | null | undefined;
  catchDate: string;
  convertedLength: string;
  convertedWeight: string;
  fishingMethod: string | undefined;
  speciesId: string | undefined;
  speciesName: string | undefined;
}

export const CatchDetailsTable = ({
  catchAndRelease,
  catchDate,
  convertedLength,
  convertedWeight,
  fishingMethod,
  speciesId,
  speciesName,
}: CatchDetailsTableProps) => {
  const catchCharacteristicsTableData = getCatchDetailsTableData({
    catchAndRelease,
    catchDate,
    convertedLength,
    convertedWeight,
    fishingMethod,
    speciesId,
    speciesName,
  });
  return (
    <table className="w-full">
      <tbody>
        {catchCharacteristicsTableData.map(({ detailName, detailValue, to }, index, { length }) => {
          const isFirstIndex = !index;
          const isLastIndex = index === length - 1;
          const shapeClassForFirstIndex = isFirstIndex ? 'rounded-t-lg' : undefined;
          const shapeClassForLastIndex = isLastIndex ? 'rounded-b-lg' : undefined;
          const shapeClass = shapeClassForFirstIndex ?? shapeClassForLastIndex;
          const backgroundClass = !(index % 2) ? ' bg-lake-fog' : undefined;
          const className = (shapeClass ?? '') + (backgroundClass ?? '') || undefined;

          return (
            <CatchDetailsRow
              className={className}
              detailName={detailName}
              detailValue={detailValue}
              key={detailName}
              to={to}
            />
          );
        })}
      </tbody>
    </table>
  );
};
